import moment from 'moment';
import React, { createContext, ReactNode, useState, useContext } from 'react';
import { useAuthContext } from '../../../stores/AuthContext';

type ProductivityContextProps = {
  companySelected: number;
  professionSelected: number;
  initialDate: any;
  finalDate: any;
  setCompanySelected: (companie: number) => void;
  setProfessionSelected: (profession: number) => void;
  updatePeriod: (initial: any, final: any) => void;
};

type Props = {
  children: ReactNode;
};

const ProductivityContext = createContext<ProductivityContextProps>({} as ProductivityContextProps);

export function ProductivityContextProvider(props: Props) {
  const { children } = props;

  const {authData} = useAuthContext();
  const [initialDate, setInitialDate] = useState<any>(moment());
  const [finalDate, setFinalDate] = useState<any>(moment());
 

  const companyId = (authData && authData.grpCompanies != 'a' && (!authData.grpCompanies.includes(","))) ?
    authData.companyId:0;

  const professionId = (authData && authData.grpCompanies == '7') ? 66 : 0;  //Maquinario Bayer

  const [professionSelected, setProfessionSelected] = useState<number>(professionId);
  const [companySelected, setCompanySelected] = useState<number>(companyId);
 

  const updatePeriod = (initial: any, final: any) => {
    setInitialDate(initial);
    setFinalDate(final);
  };

  const value = {
    companySelected,
    professionSelected,
    initialDate,
    finalDate,
    setCompanySelected,
    setProfessionSelected,
    updatePeriod,
  };
  return <ProductivityContext.Provider value={value}>{children}</ProductivityContext.Provider>;
}

export function useProductivityContext() {
  const context = useContext(ProductivityContext);

  if (typeof context === 'undefined') {
    throw new Error('ProductivityContext must be used within an useProductivityContext');
  }

  return context;
}
